import React from 'react';
import PropTypes from 'prop-types';

import ErrorBoundary from 'Components/Utility/ErrorBoundary';
import postToStructuredData from 'Components/Blog/post-to-structured-data';
import { ScriptTag } from 'Helpers/SEO/Tags';

function BlogPostStructuredData({ post }) {
  if (!post) return false;

  const schema = JSON.stringify({
    '@context': 'https://schema.org',
    ...postToStructuredData(post),
  });

  return <ScriptTag id="blog-post-schema" type="application/ld+json" script={schema} />;
}

export default function BlogPostStructuredDataWrapper(props) {
  return (
    <ErrorBoundary hideForm>
      <BlogPostStructuredData {...props} />
    </ErrorBoundary>
  );
}

BlogPostStructuredData.propTypes = {
  post: PropTypes.shape({}).isRequired,
};

BlogPostStructuredData.defaultProps = {
  buyNowProduct: null,
};
